module.exports = __webpack_public_path__ + "img/bell.png?7c6d7db4c53d19d7feea8bfefff03598";